module.exports = __webpack_public_path__ + "img/20200122125959072.5320e203.jpg";